export default __webpack_public_path__ + "static/media/marketing.c0fc96f3.jpg";